import styles from './debit-card-info.module.sass';
import { transactionTypeTranslator } from 'helpers/transaction-type-translator';
import { WalletIcon, InfoCircleFillIcon } from 'icons';

export const DebitCardInfo = ({ name, transactionTypes, balance, isBalanceLow }) => {
  const formattedNumber = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(balance);

  return (
    <div className={styles['debit-card-info']}>
      <div className={styles['debit-card-info__basic-section']}>
        <h3 className={styles['debit-card-info__basic-section__title']}>
          <WalletIcon style={{ marginRight: '6px' }} />
          {name}
        </h3>
        <div style={{ marginTop: '16px' }}>
          <span className={styles['debit-card-info__basic-section__transaction__label']}>可使用交易</span>
          <div className={styles['debit-card-info__basic-section__transaction__services-wrapper']}>
            {transactionTypeTranslator(transactionTypes).map(s => (
              <span
                key={s}
                className={styles['debit-card-info__basic-section__transaction__services-wrapper__services']}
              >
                {s}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className={styles['debit-card-info__amount-section']}>
        <div className={styles['debit-card-info__amount-section__amount']}>{formattedNumber}</div>
        {isBalanceLow && (
          <p className={styles['debit-card-info__amount-section__error-message']} style={{ marginTop: '8px' }}>
            <InfoCircleFillIcon width={20} height={20} />
            預存金餘額即將不足，請儘速補款。
          </p>
        )}
      </div>
    </div>
  );
};
